module.exports = __webpack_public_path__ + "img/guardr2.03549913.png";